import { useCookies } from 'react-cookie';
import moment from 'moment';
import { COOKIE_DEFAULT_VALUE } from '../constant/cookie';
import useEnvironment from './useEnvironment';

export default function useCookie(dependencies?: string[]) {
  const [cookies, setCookie, removeCookie] = useCookies(dependencies);
  const environment = useEnvironment();

  function setCookieWithDefault(key: string, value: string | null | any[]) {
    if (!value) {
      value = COOKIE_DEFAULT_VALUE[key];
    }
    setCookie(key, value, {
      path: '/',
      expires: moment().add(365, 'days').toDate(),
      domain: environment.REACT_APP_COOKIE_DOMAIN,
    });
  }

  function removeCookieWithDefault(key: string) {
    removeCookie(key, { path: '/' });
  }

  return {
    cookies,
    setCookie: setCookieWithDefault,
    removeCookie: removeCookieWithDefault,
  };
}
